//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('selectCheckListAdd', {
//        templateUrl: 'views/components/views/selectCheckListAdd/selectCheckListAdd.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'selectCheckListAddService', function ($stateParams, stateService, selectCheckListAddService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                itemsListChecks: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadCheckList() {
//                vm.model.itemsListChecks = await selectCheckListAddService.listCheckList({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region SAVE & GO BACK TO PREVIOUS PAGE

//            vm.goBackToPrevious = function (item) {
//                selectCheckListAddService.saveToPrevious({
//                    argtype: argType,
//                    argvalue: argValue,
//                    checklist_keyno: item.item_id
//                }).then((response) => stateService.go(response[0].webpagename, response[0].parms));
//            }

//            // #endregion SAVE & GO BACK TO PREVIOUS PAGE

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadCheckList();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
